export const hasLiquidation = (liquidation) => {
  try {
    if (Object.keys(liquidation).length == 0) return false
    return true
  } catch (error) {
    return false
  }
}


export const hasNotErrorInliquidation = (liquidation) => {
  try {
    const message = liquidation?.message
    const messsageArg = liquidation?.messsageArg
    if (message && messsageArg) {
      return false
    }
    return true
  } catch (error) {
    return false
  }
}